import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { Subject } from 'rxjs';

@Component({
  selector: 'tea-shop-fe-alert',
  standalone: false,
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.css',
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)', opacity: 0 }),
        animate('200ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateY(-100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class AlertComponent implements OnInit, OnDestroy {

  @Input() title = 'Sencha Tea';
  @Input() description? = '';
  @Input() type: 'success' | 'error' | 'info' | 'warning' | 'cart' = 'info';
  @Input() duration = 5000;
  @Input() thumbnailUrl?: string;

  public isVisible = true;
  private visibilityChange = new Subject<boolean>();
  visibilityChange$ = this.visibilityChange.asObservable();

  private timeout: any;

  typeClasses = {
    success: 'border-green-100 bg-green-50',
    error: 'border-red-100 bg-red-50',
    info: 'border-blue-100 bg-blue-50',
    cart: 'border-purple-100 bg-purple-50',
    warning: 'border-yellow-100 bg-yellow-50',
  };

  ngOnInit() {
    if (this.duration > 0) {
      this.timeout = setTimeout(() => this.close(), this.duration);
    }
  }

  ngOnDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.visibilityChange.complete();
  }

  close() {
    this.isVisible = false;
    this.visibilityChange.next(false);
  }
}
